import React from 'react';
import { createRoot, Root } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import StoreProvider from './components/store-provider/store-provider.component';
import ReducerMap from './store/reducer-map';
import SagaMap from './store/saga-map';
import Router from './modules/app/router/router.container';
import ScreenService from './services/screen-service';

const ID_CONTAINER_ROOT: string = 'root';

const root: Root = createRoot(ScreenService.getElementById(ID_CONTAINER_ROOT) as HTMLElement);

root.render(
  <StoreProvider reducerMap={ReducerMap} sagaMap={SagaMap}>
    <RouterProvider router={Router} />
  </StoreProvider>,
);
